import Backbone from 'backbone';
import NavigationHistoryModel from '../models/ArticleHistory';
import { pathname } from '../others/Configuration';
import $ from 'jquery';
import SharedDispatcher from '../others/SharedDispatcher';

// import "component?js-ProductBuy"
import 'component?js-Carousel';

export default Backbone.View.extend({
  selectors: {
    carousel: '.js-Carousel',
  },

  events: {
    'click .js-navigationHistory-destroy': 'deleteHistory',
  },

  initialize: function (options) {
    this.setElement(options.$el);

    this.model = new NavigationHistoryModel();

    this.prids = this.$el.data('product-ids').split(';');

    SharedDispatcher.trigger('carouselView:reset', false);

    this.listenTo(this.model, 'change', this.render);

    var node = this.$el.find(this.selectors.carousel);

    this.renderHistory();
  },

  // - Called when the NavigationHistory Model state changes
  //
  render: function (options) {
    switch (this.model.changed.state) {
      case 'removed':
        this.onHistoryDeleted();
        break;
    }
  },

  renderProducts: function (httpResponse) {
    // -  Replace css action class in order to have the 'AddBasket' popin
    //
    httpResponse = httpResponse.replace('js-ProductBuy-addInline', 'js-ProductBuy-add');

    var response = httpResponse.split(/--\w{8}-\w{4}-\w{4}-\w{4}-\w{12}-{0,2}/gm);

    if (!response[0].replace(/\r|\n|\s/g, '')) {
      response.splice(0, 1);
    }

    $('.js-navigationHistory .js-Carousel-container').removeClass('Carousel-container--loading').empty();
    for (var i = 0; i < response.length; i++) {
      $('.js-navigationHistory .js-Carousel-container').append(response[i]);
    }
  },

  buildGetUrl: function () {
    var params = '';
    var pridsLength = this.prids.length;
    for (var i = 0; i < pridsLength; i++) {
      params = params + 'references=' + this.prids[i];

      if (i < pridsLength - 1) {
        params = params + '&';
      }
    }

    return pathname + '/api/navigation/rest/v1/thumbnail/suggestions/basket?' + params;
  },

  renderHistory: function () {
    if (this.prids.length == 0) {
      return;
    }

    var self = this;
    var url = this.buildGetUrl();
    $.get(url).done(function (response) {
      self.renderProducts(response);
    });
  },

  // - Initialize navigation history deletion
  //
  deleteHistory: function (evt) {
    this.model.fetch({ action: 'remove', dataType: 'html' });
  },

  // - Happens when the navigation history has been deleted
  //
  onHistoryDeleted: function () {
    this.$el.fadeOut();
  },
});
